<div class="text-center">
    <span><i class="fa-solid fa-spinner fa-spin"></i></span>
</div>